"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    avatar: {
      backgroundColor: palette.error.main
    },
    root: {
      borderTop: "4px solid ".concat(palette.error.main)
    },
    submitButton: {
      backgroundColor: palette.error.main,
      paddingLeft: spacing(1),
      paddingRight: spacing(1),
      width: 156
    },
    cancelButton: {
      paddingLeft: spacing(1),
      paddingRight: spacing(1),
      width: 156
    },
    actions: {
      justifyContent: 'space-between'
    }
  };
});

var UnsubscribedRecipientConfirmation = function UnsubscribedRecipientConfirmation(props) {
  var customClasses = useStyles();
  return /*#__PURE__*/_react.default.createElement(_ui.ModalConfirmationMessage, (0, _extends2.default)({
    title: "Sorry, Alyce cannot send this recipient an invitation",
    icon: "eye-slash",
    customClasses: customClasses,
    submitButtonText: "Cancel invitation",
    cancelButtonText: "Change recipient"
  }, props), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "Sorry, this person has opted-out of Alyce gifts."), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 2,
    pb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "How do you wish to continue?")));
};

var _default = UnsubscribedRecipientConfirmation;
exports.default = _default;